import React from 'react';
import { SearchablePeriscopeFieldGroupListV3 } from '@periscopes/general/fields/SearchablePeriscopeFieldGroupListV3';
function mapGroupForFlows(group) {
    return {
        fields: group.fields,
        name: group.name
    };
}
export const FlowByNodeTab = ({ index, sonarObjectId }) => {
    const targetUri = `v3/salesforce/flows/${sonarObjectId}/RefsByNode`;
    return (React.createElement(SearchablePeriscopeFieldGroupListV3, { mapGroup: mapGroupForFlows, parentIndex: index, showParents: true, uri: targetUri, useDql: true }));
};
